import React from 'react';
import PropTypes from 'prop-types';

import syncApi from 'ecommerce/api/sync';
import DraftSync from './components/draftSync';
import useEditorContext from '../context/editorContext';
import useDraftSync from './hooks/useDraftSync';
import useTOC from './hooks/useTOC';

import BookPreview from './preview/book';
import CalendarPreview from './preview/calendar';
import BookComplexPreview from './preview/book-complex';
import DefaultPreview from './preview/default';
import PolotnoPreview from './preview/polotno';
import DraftSource from './components/draftSource';

const getPreviewComponent = (config = { preview: 'default' }) => {
  switch (config.preview) {
    case 'book':
      return BookPreview;

    case 'book-complex':
      return BookComplexPreview;

    case 'calendar':
      return CalendarPreview;

    case 'polotno':
      return PolotnoPreview;

    default:
      return DefaultPreview;
  }
};

const NewEditorPreview = props => {
  const editorContext = useEditorContext();

  const draftSync = useDraftSync(props.item, props.product, props.template);
  const toc = useTOC(props.item, props.template);

  const handleOnAddToCartClick = async ({ data, errors }) => {
    if (errors) {
      return;
    }

    let draftLastModified;
    // in some cases, editorItem has no draftId (e.g. editing already ordered item)
    if (props.item.draftId) {
      const { data: syncData } = await syncApi(editorContext.accessToken).updateProductDraftState(
        props.item.draftId,
        'cart',
      );

      if (syncData) {
        draftLastModified = syncData.updated_at;
      }
    }

    props.onFinish(data, { draftLastModified });
  };

  const handleOnChangeDraftName = name => {
    editorContext.setDraftName(props.item.id, name);
  };

  const PreviewComponent = getPreviewComponent(props.config);

  return (
    <PreviewComponent
      actionBar={
        <>
          <DraftSource item={props.item} template={props.template} />
          <DraftSync
            state={draftSync.state}
            name={props.item.draftName}
            onNameChange={handleOnChangeDraftName}
            onSaveClick={draftSync.save}
          />

          {/*
            TODO
            - prepare custom action bar for each type of source
           */}
        </>
      }
      onSuccess={handleOnAddToCartClick}
      updateTOC={toc.update}
    />
  );
};

NewEditorPreview.propTypes = {
  id: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  params: PropTypes.array.isRequired,
  config: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired,
  onFinish: PropTypes.func.isRequired,
};

export default NewEditorPreview;
